/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */
import React from "react";
import DialogModal from "../DialogModal/DialogModal";
import Button from "@mui/material/Button";
import { Link } from "react-router-dom";
import Grid from "@mui/material/Grid";
import { getCaseLink } from "../../services/productService";
import { Typography } from "@mui/material";
import { AbstractCase } from "../../types/Entities/AbstractCase";

type PoAVerificationModalProps = {
  divorce: AbstractCase;
};

const PoAVerificationModal = ({ divorce }: PoAVerificationModalProps) => {
  const actions = (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Button fullWidth={true} component={Link} to={getCaseLink(divorce) + "/antrag"} variant={"contained"} color={"primary"}>
          Zur Vollmacht
        </Button>
      </Grid>
      <Grid item xs={12}>
        <Button fullWidth={true} component={Link} to={"/servicewelt"} variant={"text"} color={"primary"}>
          Zurück zur Übersicht
        </Button>
      </Grid>
    </Grid>
  );

  return (
    <DialogModal open={divorce.powerOfAttorney === null} title={"Jetzt Verfahrenskostenhilfe-Assistent freischalten!"} actions={actions}>
      <Typography sx={{ textAlign: "left" }}>Damit wir Sie bei Ihrer Scheidung unterstützen dürfen, müssen Sie uns zunächst die Vollmacht erteilen.</Typography>
      <Typography sx={{ textAlign: "left", fontWeight: 500 }}>
        Sobald Sie Vollmacht erteilt haben, erhalten Sie exklusiv und kostenlos Zugriff auf den Verfahrenskostenhilfe-Assistenten!
      </Typography>
    </DialogModal>
  );
};

export default PoAVerificationModal;
